import React from 'react';
import ReportDataSet, {
  isOrganizationReportData,
} from '../../models/general/notifications/report-data-set';
import { DateTime } from 'luxon';
import { useTranslation } from 'react-i18next';
import { dateToStringFormat } from '@common/utils/date';
import PdfWrapper from './PdfWrapper';
import { ReportType } from 'services/analytics-events';
import OrganizationStatsPages from './OrganizationStatsPages';

const DashboardSummaryReport: React.FC<{
  reportDataSets: ReportDataSet[];
  start: DateTime;
  end: DateTime;
}> = ({ reportDataSets, start, end }) => {
  const { t } = useTranslation();

  const pages =
    reportDataSets.reduce(
      (acc, dataset) => (acc += isOrganizationReportData(dataset.data) ? 2 : 1),
      0,
    ) + 1;
  let currentPageIndex = 0;

  return (
    <React.Fragment>
      <PdfWrapper
        title={t('notification-trigger-DASHBOARD_SUMMARY')}
        reportType={ReportType.DashboardSummary}
        subtitle={`${dateToStringFormat(start)} - ${dateToStringFormat(end)}`}
      >
        {reportDataSets != null &&
          reportDataSets.map((dataset) => {
            if (!isOrganizationReportData(dataset.data)) return null;

            const statsPage = (
              <OrganizationStatsPages
                key={dataset.id}
                data={dataset.data}
                name={dataset.name}
                pageIndex={currentPageIndex}
                pages={pages}
                start={start}
                end={end}
              />
            );
            currentPageIndex += 2;

            return statsPage;
          })}
      </PdfWrapper>
    </React.Fragment>
  );
};

export default DashboardSummaryReport;
